module.exports = "/assets/bf21ba5f255011e7eb3b71212026f75d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ME.png
// module id = 2735
// module chunks = 0